import { render, staticRenderFns } from "./DispatchShipToTable.vue?vue&type=template&id=78764283&scoped=true&"
import script from "./DispatchShipToTable.vue?vue&type=script&lang=js&"
export * from "./DispatchShipToTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatchShipToTable.vue?vue&type=style&index=0&id=78764283&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78764283",
  null
  
)

export default component.exports